import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {   NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-channels-layout',
  templateUrl: './channels-layout.component.html',
  styleUrls: ['./channels-layout.component.scss']
})
export class ChannelsLayoutComponent {

  constructor(
    private themeService: NbThemeService
  ) {
  
    this.themeService.changeTheme('default');


  }

}

